module.exports = __webpack_public_path__ + "static/img/iconmenu07.570e2e48.svg";